import { render, staticRenderFns } from "./AddGuidancePage.vue?vue&type=template&id=6220351a&"
import script from "./AddGuidancePage.vue?vue&type=script&lang=js&"
export * from "./AddGuidancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports